define('TavanoTeam.DoubleUnitSales.Submit.View'
,	[
		'tavanoteam_submit.tpl'
	,	'Utils'
	,	'Backbone'
    ,	'jQuery'
    ,   'Cart.Confirmation.View'
    ,   'GlobalViews.Confirmation.View'
    ,   'TavanoTeam.DoubleUnitSales.Request.View'
    ,   'LiveOrder.Model'
    ,   'SC.Configuration'
    ,   'Facets.Translator'
	,	'underscore'
	]
,	function (
        tavanoteam_submit_tpl
	,	Utils
	,	Backbone
    ,	jQuery
    ,   CartConfirmationView
    ,   GlobalViewsConfirmationView
    ,   RequestView
    ,   LiveOrderModel
    ,   Configuration
    ,   FacetsTranslator
	,	_
	)
{
	'use strict';

	return Backbone.View.extend({

		template: tavanoteam_submit_tpl,
		
		events: {
			'click [data-action="tt-add-to-cart"]': 'addToCart',
			'click [data-action="request-pricing"]': 'requestPricing'
		},

		initialize: function (options) {

            this.itemInfo =  options.pdp.getItemInfo();
            this.cart = options.cart;

            //Get Discontinued Message
            this.container = options.container;
            this.environment = this.container.getComponent("Environment");
            
            this.discontinuedMessage = this.environment.getConfig("TTPDPDiscontinuedItems") || {message: "This item is discontinued.", help:{message:"",phone:"",mail:""}};

            this.showDiscontinued = false;

            this.ttseoprice = "";

            //console.log(this.itemInfo)
            if (this.itemInfo) {
                if (this.itemInfo.item) {
                    
                    if (this.itemInfo.item.custitem_item_master_status.indexOf('DISCONTINUED') !== -1 || this.itemInfo.item.custitem_item_master_status.indexOf('discontinued') !== -1) {
                        this.showDiscontinued = true;
                    }

                    if(this.itemInfo.item.onlinecustomerprice_detail.onlinecustomerprice){
                        this.ttseoprice = this.itemInfo.item.onlinecustomerprice_detail.onlinecustomerprice;
                      //  console.log("Price: "+this.ttseoprice);
                    }

                }

            } 
            
            //Set Hazmat Items Properties and Get Configuration for Popup Modal

            this.layout = this.container.getComponent("Layout");
            this.application = this.layout.application;
            this.getLayout = this.application.getLayout();

            sessionStorage.setItem("addHazardousItemToCart", "false"); //If Hazmat Item can be Added To Cart

            this.isHazardous = false;
            if (this.itemInfo) {
                if (this.itemInfo.item) {
                    this.isHazardous = this.itemInfo.item.custitem_hazmat_un_number != "" ? true : false;
                }
            }

			this.hazmatDisclaimerPopupEnable = this.environment.getConfig("TTPDPHazmatItems.hazmatDisclaimerPopupEnable");
			this.hazmatDisclaimerPopupMessage = this.environment.getConfig("TTPDPHazmatItems.hazmatDisclaimerPopupMessage") || "Notice: Hazardous chemicals and products will incur additional Hazmat Fees and/or mandatory shipment via LTL Motor Freight";
        
        },

        addToCart: function(e){

           var itemId = this.itemInfo.item.internalid;
           var options = this.itemInfo.options;

           var unit = jQuery("#unit-level").val();
           var quantityUnit = "#" + unit + '-quantity';

           var quantity = $(quantityUnit).val();
           var hasQty = quantity != '' &&  quantity > 0;

            if(hasQty){

                var line = { line: this.getLineObject(itemId, options, quantity) };
                var opt = this.options.container;

                var addHazardousItemToCart = sessionStorage.getItem("addHazardousItemToCart");
                console.log('Get Hazardous Item Data:', {addHazardousItemToCart: addHazardousItemToCart, isHazardous: this.isHazardous});

                 //Display Hazmat Disclaimer Pop-up Confirmation Message for Hazmat Items
                if (this.hazmatDisclaimerPopupEnable && this.isHazardous && addHazardousItemToCart == "false") {

                    //Display Hazmat Disclaimer Pop-up Confirmation Message for Hazmat Items

                    this.lineItem = {line: line, opt: opt};

                    var confirmationView = new GlobalViewsConfirmationView({
                        title: Utils.translate("Hazardous Item"),
                        body: Utils.translate(
                            this.hazmatDisclaimerPopupMessage
                        ),
                        callBack: _.bind(this.acceptModalCallback, this),
                        confirmLabel: Utils.translate("Accept"),
                        cancelLabel: Utils.translate("Reject"),
                        class: "hazardous-item-global-views-modal-content-actions",
                        className: "hazardous-item-global-views-modal-content-body",
                        autohide: true
                    });
                    
                    //On Modal Close
                    confirmationView.on('modal-close', function() {
                        sessionStorage.setItem("addHazardousItemToCart", "false");
                    });

                    return this.getLayout.showInModal(confirmationView);

                } else {

                    //Add Item to Cart
                    var cart_promise = this.cart.addLine(line);
                    cart_promise.done(function() {
                        var view = new CartConfirmationView({
                            application: opt,
                            model: LiveOrderModel.getInstance().getLatestAddition()
                        });
                        view.showInModal();
                    });

                }
     
                return false;
            }
            $("#invalid-qty").show();
            return;
        },
        
        acceptModalCallback: function acceptModalCallback() {
            sessionStorage.setItem("addHazardousItemToCart", "true");
            this.addHazardousItemToCart(this.lineItem.line, this.lineItem.opt);
        },

        requestPricing: function(){
            var layout = this.options.container.getLayout();
            var view = new RequestView(this.itemInfo);
            layout.showInModal(view);
        },

        addHazardousItemToCart: function addHazardousItemToCart(line, opt) {

            //Add Item to Cart
            var cart_promise = this.cart.addLine(line);
            cart_promise.done(function() {
                var view = new CartConfirmationView({
                    application: opt,
                    model: LiveOrderModel.getInstance().getLatestAddition()
                });
                view.showInModal();
            });

        },

        // itemId: <string>
        // options: array of objects { cartOptionId: <string>, internalId: <string> 
		getLineObject: function (itemId, options, quantity) {
            var qty = Number(quantity) || 1;
            var optionObject = [];
            var price = "";
            var unit = jQuery("#unit-level").val();
            var level = "#" + unit + '-level';
            var caseLevel = $(level).val();
            price = caseLevel += "-" + unit;
    
            _.each(options, function (o) {
               optionObject.push({
                    cartOptionId: o.cartOptionId,
                    value: { internalid: o.cartOptionId == "custcol_tt_cutom_price" ? price : "" }
                })
               optionObject.push({
                    cartOptionId: 'custcol_360capsci_unit_type',
                    value: { internalid: unit }
                })
            });
            return {
                quantity: qty,
                item: {
                    internalid: itemId
                },
                options: optionObject
            }
        },

        getContext: function getContext(){
            var url =  window.location.href;
            
            var containsCart = false;

            if (url.indexOf("cart") == -1) {
                containsCart = true
            }
            var discontinued =  true;
            // var hasCart = !window.location.href.includes('cart');

            try {
                if (this.itemInfo.item.custitem_item_master_status == "MANUFACTURER DISCONTINUED - Display on Web") {
                    discontinued = false;
                }
            }catch (e) {
                console.log(e);
            }
            var isAddToCartActive = this.itemInfo ? this.itemInfo.item.custitem_item_master_status == "Active Item Displayed With Price" : "";

            var layout = this.options.container.getLayout();
           if(!discontinued){
               layout.once("afterAppendView", function (view) {
                   //$(".product-list-control-button-wishlist").hide()
               })
           }


            return {
                showAddToCart: containsCart,
                isAddToCartActive: isAddToCartActive,
				showDiscontinued: this.showDiscontinued,
                discontinued:discontinued,
                discontinuedMessage: this.discontinuedMessage,
                seoitemprice: this.ttseoprice
            }

        }
    }) 
});
